import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Form, Input } from 'semantic-ui-react';
import { clientError, firstError, validationClasses } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import fields, { globalFieldLengths } from '@/constants/fields';
import MarkdownEditor from '@/components/text-editors/MarkdownEditor';
import FormValidationError from '@/components/errors/FormValidationError';
import Dialog from '@/components/dialogs/Dialog';
import { hideRenameClause, updateActiveClauseProperties } from '../actions';

const RenameClauseDialog = ({
  description,
  hide,
  name,
  saveErrors,
  saveStatus,
  updateProperties,
  theme,
}) => {
  const intl = useIntl();
  const setErrors = (newErrors) => (updateProperties({ saveErrors: newErrors }));

  const nameChange = (e) => {
    updateProperties({ name: e.target.value });
  };

  const descriptionChange = (value) => {
    updateProperties({ description: value });
  };

  const validateForm = () => {
    const validationErrors = [];

    if (description && description.length > globalFieldLengths.description) {
      validationErrors.push(
        clientError(
          { entity: 'clause' },
          intl.formatMessage({ id: 'save.cohort.validation.clause.description.title' }),
          intl.formatMessage({ id: 'validation.max.length' }, { maximum: globalFieldLengths.description }),
          [fields.DESCRIPTION],
        ),
      );
    }

    return validationErrors;
  };

  const checkForErrors = () => {
    const validationErrors = validateForm();
    setErrors(validationErrors);

    return validationErrors;
  };

  const submitForm = () => {
    const validationErrors = checkForErrors();

    if (validationErrors.length === 0) {
      hide(false);
    }
  };

  const nameError = saveErrors ? saveErrors.find((e) => (e.fields.includes(fields.NAME))) : null;
  const descriptionError = saveErrors ? saveErrors.find((e) => (e.fields.includes(fields.DESCRIPTION))) : null;

  return (
    <Dialog
      className="aridhia-save-cohort-dialog"
      icon="edit"
      minimumDataEntryMet={name}
      onClose={() => hide(true)}
      onSave={submitForm}
      saveMessageId="actions.modify"
      theme={theme}
      title={intl.formatMessage({ id: 'save.cohort.clause.update.title' })}
    >
      <Form autoComplete="off" onSubmit={submitForm} error={firstError(saveErrors) !== null}>
        <FormValidationError
          error={nameError}
          htmlFor="cohort_name"
          labelId="save.cohort.clause.name"
        >
          <Input
            id="cohort_name"
            autoFocus
            disabled={saveStatus === states.PENDING}
            type="custom"
            size="large"
            placeholder={intl.formatMessage({ id: 'save.cohort.clause.name.placeholder' })}
            value={name}
            maxLength={globalFieldLengths.name}
            onChange={nameChange}
            className={validationClasses(nameError)}
          />
        </FormValidationError>
        <FormValidationError
          error={descriptionError}
          htmlFor="cohort_query_description"
          labelId="save.cohort.clause.description"
        >
          <MarkdownEditor
            id="cohort_query_description"
            disabled={saveStatus === states.PENDING}
            value={description}
            onChange={descriptionChange}
            maxEditorHeight={80}
            minPreviewHeight={94}
            className={validationClasses(descriptionError)}
          />
        </FormValidationError>
      </Form>
    </Dialog>
  );
};

const mapStateToProps = ({
  cohorts: {
    activeClause: {
      name, description, saveErrors, saveStatus,
    },
  },
}) => ({
  name,
  saveErrors,
  saveStatus,
  description,
});

const mapDispatchToProps = {
  hide: hideRenameClause,
  updateProperties: updateActiveClauseProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(RenameClauseDialog);
